<template>
  <div>
    

    <b-row class="mb-1">
      <b-col md="9">
        <h4 class="font-weight-bold ml-1">Oversikt</h4>
      </b-col>

      <!-- <b-col md="3">
        <b-button
          class="float-right"
          variant="primary"
          @click="newOrder()"
        >Ny bestilling</b-button>
      </b-col> -->

    </b-row>



    <!-- / Counters -->

    <!-- Calendar -->



    <!-- / Statistics Today-->

    <div>
      <b-row>
        <b-col class="col-md-12 mt-3">

          <b-row>
            <b-col md="12" lg="10" xl="9">

              <!-- Counters -->
              <div class="row">
                <div class="col-sm-6 col-xl-3">
                  <b-card class="mb-1">
                    <div class="d-flex align-items-center">
                      <div class=""></div>
                      <div class="ml-3">
                        <div class="text-muted small">Bestillinger</div>
                        <div class="text-large">
                          {{ orderStatusNew.length | numeralFormat }}
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>

                <div class="col-sm-6 col-xl-3">
                  <b-card class="mb-1">
                    <div class="d-flex align-items-center">
                      <div class=""></div>
                      <div class="ml-3">
                        <div class="text-muted small">Ordre</div>
                        <div class="text-large">
                          {{ orderStatusOrder.length | numeralFormat }}
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>

                <div class="col-sm-6 col-xl-3">
                  <b-card class="mb-1">
                    <div class="d-flex align-items-center">
                      <div class=""></div>
                      <div class="ml-3">
                        <div class="text-muted small">I arbeid</div>
                        <div class="text-large">
                          {{ orderStatusWorking.length | numeralFormat }}
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>

                <div class="col-sm-6 col-xl-3">
                  <b-card class="mb-1">
                    <div class="d-flex align-items-center">
                      <div class=""></div>
                      <div class="ml-3">
                        <div class="text-muted small">Arbeid avsluttet</div>
                        <div class="text-large">
                          {{ orderStatusFinished.length | numeralFormat }}
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>

              </div>

              <!-- Incoming orders -->

               <b-card class="mt-3 mb-3" v-if="user.role.id == '600fe2dc0b7e124b5c5f7f3b'">
                <h6>Bestillinger</h6>

                <b-table :items="ordersIncoming" :fields="ordersTableIncoming" :hover="true">
                  <template v-slot:cell(status)="data">
                    <b-badge pill v-if="data.item.status == 'Bestilling'" variant="secondary">{{ data.item.status }} </b-badge>
                    <b-badge pill v-if="data.item.status == 'Ordre'" variant="primary">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'I arbeid'" variant="dark">{{ data.item.status }}  </b-badge>
                    <b-badge pill v-if="data.item.status == 'Arbeid avsluttet'" variant="warning">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'Til fakturering'" variant="info">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'Fakturert'" variant="success">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'Kansellert'" variant="danger">{{ data.item.status }}</b-badge>
                  </template>

                  <template v-slot:cell(ordertitle)="data">
                    <b-link class="link" :href="'#/dashboard/order-edit/' + data.item.id">
                      <span v-if="data.item.customer_company != null">
                        {{ data.item.ordernumber }} -
                        {{ data.item.customer_company.name }}
                        <span v-if="data.item.site != null">({{ data.item.site.name }})</span></span>
                    </b-link>
                  </template>

                  <template v-slot:cell(vessel)="data">
                    <span v-if="data.item.vessel.name != null">{{ data.value.name }}</span>
                  </template>

                  <template v-slot:cell(captain)="data">
                    <span v-if="data.item.captain != null">{{ data.value }}</span>
                  </template>

                  <template v-slot:cell(startdate)="data">
                    {{ $date(data.value).format("DD.MM.YYYY") }}
                  </template>

                  <template v-slot:cell(createdAt)="data">
                    {{ $date(data.value).format("DD.MM.YYYY") }}
                  </template>

                 <template v-slot:cell(updatedAt)="data">
                    {{ data.value | dayjs("from") }}
                  </template>

                  <template v-slot:cell(attachments)="data">
                    <span v-if="data.item.attachments.length != 0"><i class="ion ion-ios-attach"></i></span>
                  </template>


                </b-table>
              </b-card>

              <!-- Next orders -->

              <b-card class="mb-3">
                <h6>Kommende ordrer</h6>

                <b-table  :items="orders" :fields="ordersTable" :hover="true">
                  <template v-slot:cell(status)="data">
                    <b-badge pill v-if="data.item.status == 'Bestilling'" variant="secondary">{{ data.item.status }} </b-badge>
                    <b-badge pill v-if="data.item.status == 'Ordre'" variant="primary">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'I arbeid'" variant="dark">{{ data.item.status }}  </b-badge>
                    <b-badge pill v-if="data.item.status == 'Arbeid avsluttet'" variant="warning">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'Til fakturering'" variant="info">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'Fakturert'" variant="success">{{ data.item.status }}</b-badge>
                    <b-badge pill v-if="data.item.status == 'Kansellert'" variant="danger">{{ data.item.status }}</b-badge>
                  </template>

                  <template v-slot:cell(ordertitle)="data">
                    <b-link class="link" :href="'#/dashboard/order-edit/' + data.item.id">
                      <span v-if="data.item.customer_company != null">
                        {{ data.item.ordernumber }} -
                        {{ data.item.customer_company.name }}
                        <span v-if="data.item.site != null">({{ data.item.site.name }})</span></span>
                    </b-link>
                  </template>

                  <template v-slot:cell(vessel)="data">
                    <span v-if="data.item.vessel != null">{{ data.value.name }}</span>
                  </template>

                  <template v-slot:cell(captain)="data">
                    <span v-if="data.item.captain != null">{{ data.value }}</span>
                  </template>

                  <template v-slot:cell(startdate)="data">
                    {{ $date(data.value).format("DD.MM.YYYY") }}
                  </template>

                  <template v-slot:cell(createdAt)="data">
                    {{ $date(data.value).format("DD.MM.YYYY") }}
                  </template>

                 <template v-slot:cell(updatedAt)="data">
                    {{ data.value | dayjs("from") }}
                  </template>

                  <template v-slot:cell(attachments)="data">
                    <span v-if="data.item.attachments.length != 0"><i class="ion ion-ios-attach"></i></span>
                  </template>


                </b-table>
              </b-card>

            </b-col>



            <b-col md="12" lg="2" xl="3">

              <!-- Calendar -->

              <v-calendar class="mb-3" is-expanded :attributes="calendar" show-iso-weeknumbers
                :columns="$screens({ default: 1, xs: 1, sm:1, md: 2, lg: 1, xl: 1 })" :rows="$screens({ default: 1, xs: 1, sm:1, md: 1, lg: 3, xl: 3 })" />

              
              <!-- Timeline -->

              <!-- <b-card class="mb-3">
                <h6>Tidslinje</h6>
                <hr>

                <ul class="timeline">
                  <li v-for="order in orderBy(orders, 'startdate')" :key="order.id">

                    <b-badge pill v-if="order.status == 'Bestilling'" variant="info">
                      {{ order.status }}
                    </b-badge>

                    <b-badge pill v-if="order.status == 'Ordre'" variant="warning">
                      {{ order.status }}
                    </b-badge>
                    <b-badge pill v-if="order.status == 'I arbeid'" variant="primary">
                      {{ order.status }}
                    </b-badge>

                    <b-badge pill v-if="order.status == 'Arbeid avsluttet'" variant="secondary">{{ order.status }}
                    </b-badge>

                    <b-badge pill v-if="order.status == 'Utført'" variant="success">
                      {{ order.status }}
                    </b-badge>

                    <b-badge pill v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>

                    <b-link class="link" :href="'#/dashboard/order-edit/' + order.id">

                      <h4 class="font-weight-bold mt-2">
                        {{ order.ordernumber }} - {{ order.customer_company.name }}
                        <span v-if="order.site.name != null">({{ order.site.name }})</span>
                      </h4>
                    </b-link>

                    <h5> {{ order.type }} </h5>
                    <h5>Startdato: {{ $date(order.startdate).format("DD.MM.YYYY") }}
                      ({{ order.startdate | dayjs("from") }}) </h5>
                    <h5>Sluttdato: {{ $date(order.enddate).format("DD.MM.YYYY") }} ({{ order.enddate | dayjs("from") }})
                    </h5>
                    <h5 v-if="order.vessel != null">Fartøy: {{ order.vessel.name }} </h5>
                    <h5 v-if="order.captain != null">Kaptein: {{ order.captain.name }} </h5>

                  </li>
                </ul>
              </b-card>
               -->
              <!-- Map with vessels -->

              <!-- <b-card v-if="this.vessels[0] != null">

                <h6>Fartøy</h6>
                <hr>

                <div>
                  <l-map ref="map" :zoom="zoom" :center="center" style="height: 70vh" :options="{ zoomControl: true }">

                    <l-tile-layer v-for="tileProvider in tileProviders" :key="tileProvider.name"
                      :name="tileProvider.name" :visible="tileProvider.visible" :url="tileProvider.url"
                      :attribution="tileProvider.attribution" layer-type="base" />

                    <l-circle :v-if="vessels[0] != null" v-for="vessel in vessels" :key="vessel.mmsi"
                      :lat-lng="[vessel.lat, vessel.lng]" :color="circleVessel.color" :radius="circleVessel.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        {{ vessel.name }}
                      </l-tooltip>
                    </l-circle>
                  </l-map>
                </div>


              </b-card> -->

            </b-col>

          </b-row>
          <!-- / Latest orders -->

        </b-col>

        <!-- Log -->

        <!-- <b-col class="col-md-4">
  
          <b-card class="mt-3">
            <h5>{{ $t("dashboard.log") }}</h5>
            <hr />

            <vue-json-pretty :data="logs"> </vue-json-pretty>
          </b-card>
        </b-col> -->

        <!-- / Log -->
      </b-row>
    </div>

    <!-- Welcome modal -->

    <b-modal id="welcomeModal" size="lg" title="Welcome to Aquaservices!" cancel-disabled>
      <div class="text-center">
        <!-- <youtube video-id="bBMH16LR7sQ" :resize="false" :fitParent="true" /> -->

        <br />
      </div>

      <template v-slot:modal-footer="{}">
        <!-- Button with custom close trigger value -->

        <b-form-checkbox class="float-left mr-3" v-model="welcomeHide">
          Hide this message on welcome
        </b-form-checkbox>

        <b-button variant="primary" @click="closeWelcomeModal()">
          Close
        </b-button>
      </template>
    </b-modal>

    <!-- / Welcome modal -->
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  
  import Vue2Filters from "vue2-filters";
  

  

  import {
    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LPopup,
    LCircle,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LControlZoom,
    LControlAttribution,
    LControlScale,
  } from "vue2-leaflet";

  import {
    Icon
  } from "leaflet";
  delete Icon.Default.prototype._getIconUrl;

  Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });

  export default {
    name: "dashboard",
    metaInfo: {
      title: "Dashboard",
    },
    mixins: [Vue2Filters.mixin],
    components: {  
      LMap,
      LTileLayer,
      LMarker,
      LControlLayers,
      LControl,
      LPopup,
      LCircle,
      LPolyline,
      LLayerGroup,
      LTooltip,
      LControlZoom,
      LControlAttribution,
      LControlScale,
    },
    data() {
      return {
        user: {},
        orders: [],
        ordersIncoming: [],
        workorders: [],
        logs: [],
        vessels: [],
        calendar: [],
        ordersTable: [{
            key: "status",
            label: "Status",
            sortable: true
          },
          {
            key: "ordertitle",
            label: "Ordre",
            sortable: true,
            class: "text-left",
          },
          {
            key: "type",
            label: "Type",
            sortable: true
          },
          {
            key: "vessel",
            label: "Fartøy",
            sortable: true
          },
          {
            key: "startdate",
            label: "Startdato",
            sortable: true
          },
          {
            key: "updatedAt",
            label: "Sist oppdatert",
            sortable: true
          },
          {
            key: "attachments",
            label: "",
          },
        ],
        ordersTableIncoming: [{
            key: "status",
            label: "Status",
            sortable: true
          },
          {
            key: "ordertitle",
            label: "Ordre",
            sortable: true,
            class: "text-left",
          },
          {
            key: "type",
            label: "Type",
            sortable: true
          },
          {
            key: "createdAt",
            label: "Bestilt",
            sortable: true
          },
          {
            key: "updatedAt",
            label: "Sist oppdatert",
            sortable: true
          },
          {
            key: "attachments",
            label: "",
          },
        ],
        isLoading: false,
        fromDate: {},
        toDate: {},
        lastUpdate: null,
        zoom: 4,
        tileProviders: [{
            name: "Mapbox",
            visible: true,
            url: "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
            attribution: '<a href="https://www.aquaservices.no">Aquaservices</a> ',
          },

          {
            name: "Mapbox Satelitte",
            visible: false,
            url: " https://api.mapbox.com/styles/v1/packtracker-com/ckn0730vs0urb17prj3ndsm1p/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
            attribution: '<a href="https://www.aquaservices.no">Aquaservices</a> ',
          },
          {
            name: "OpenStreetMap",
            visible: false,
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: '<a href="https://www.aquaservices.no">Aquaservices</a> ',
          },
        ],
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution: '<a href="https://www.aquaservices.no">Aquaservices</a> ',
        center: L.latLng(65.355, 14.7487),
        circle: {
          radius: 100,
          color: "#022D56",
        },

        circleVessel: {
          radius: 1,
          color: "#025D46",
        },
      };
    },
    computed: {
      orderStatusNew() {
        return this.orders.filter((order) => order.status == "Bestilling");
      },
      orderStatusOrder() {
        return this.orders.filter((order) => order.status == "Ordre");
      },
      orderStatusNotstarted() {
        return this.orders.filter((order) => order.status == "Ikke påbegynt");
      },
      orderStatusFinished() {
        return this.orders.filter((order) => order.status == "Arbeid avsluttet");
      },
      orderStatusWorking() {
        return this.orders.filter((order) => order.status == "I arbeid");
      },
      orderStatusComplete() {
        return this.orders.filter((order) => order.status == "Fakturert");
      },
    },
    methods: {
      getUser() {
        axios.get("https://api.eines-as.no/users/me").then((res) => {
          this.user = res.data;
          this.company = res.data.company;

          if (this.user.wizard == false) {
            this.$router.push("/wizard");
          } else {
            if (this.company.type == "Customer") {
              this.$router.push("/customer/home");
            }
            if (this.isLoggedIn == true) {
              this.$router.push("/dashboard/home");
            }
          }
        });
      },
      getOrders() {
        this.isLoading = true;
        var company = localStorage.getItem("company");

        axios
          .get(
            "https://api.eines-as.no/orders?_sort=startdate:ASC&status_eq=Ordre&status_eq=I arbeid&status_eq=Arbeid avsluttet&_where[supplier_company]=" +
            company
          )
          .then((res) => {
            this.orders = res.data;

            // Orders to calendar attributes
            var orderArray = [];

            this.orders.forEach((order) => {
              if (order.status == "Bestilling") {
                var dotcolor = "gray";
              }
              if (order.status == "Ordre") {
                var dotcolor = "blue";
              }
              if (order.status == "I arbeid") {
                var dotcolor = "black";
              }
              if (order.status == "Arbeid avsluttet") {
                var dotcolor = "yellow";
              }
              if (order.status == "Utført") {
                var dotcolor = "green";
              }
              if (order.status == "Klar til fakturering") {
                var dotcolor = "green";
              }
              if (order.status == "Fakturert") {
                var dotcolor = "green";
              }
              if (order.status == "Kansellert") {
                var dotcolor = "red";
              }

              var calendarObject = {
                highlight: {
                  start: {
                    fillMode: "outline",
                    color: dotcolor
                  },
                  base: {
                    fillMode: "light",
                    color: dotcolor
                  },
                  end: {
                    fillMode: "solid",
                    color: dotcolor
                  },
                },
                dot: dotcolor,
                dates: {
                  start: order.startdate,
                  end: order.enddate
                },
                popover: {
                  label: order.ordernumber +
                    " - " +
                    order.customer_company.name +
                    " (" +
                    order.site.name +
                    ") - " +
                    order.type +
                    " - " + order.status,
                  visibility: "focus",
                },
              };

              orderArray.push(calendarObject);
            });

            this.calendar = orderArray;

            this.isLoading = false;
          });
      },
      getOrdersIncoming() {
        this.isLoading = true;
        var company = localStorage.getItem("company");

        axios
          .get(
            "https://api.eines-as.no/orders?_sort=createdAt:DESC&status_eq=Bestilling&_where[supplier_company]=" +
            company
          )
          .then((res) => {
            this.ordersIncoming = res.data;
            this.isLoading = false;
          });
      },
      getVessels() {
        var company = localStorage.getItem("company");

        axios
          .get(`https://api.eines-as.no/vessels?_where[company]=` + company)
          .then((response) => {
            this.vessels = response.data;

          });
      },
      getLogs() {
        axios
          .get("https://api.eines-as.no/log?_sort=startdate:DESC")
          .then((res) => {
            this.logs = res.data;
          });
      },
      editOrder(orderId) {
        this.$router.push("/dashboard/order-edit/" + orderId);
      },
      getDate() {
        this.lastUpdate = new Date();
        this.fromDate = new Date();
        this.toDate = new Date();
        this.disabledDates = {
          from: new Date(),
        };
      },
      refreshMap() {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 250);
      },
    },
    beforeMount() {
      this.getUser();
      //const localUserId = localStorage.getItem("userId");
    },
    created: function () {
      this.getOrders();
      this.getOrdersIncoming()
      this.getVessels()
    },

    // Resize charts
    //

    mounted() {
      const charts = this.$children.filter((component) =>
        /-chart\d+$/.test(component.$options._componentTag)
      );

      const resizeCharts = () =>
        charts.forEach((chart) => chart._data._chart.resize());

      // For performance reasons resize charts on delayed resize event
      this.layoutHelpers.on("resize.dashboard-1", resizeCharts);
    },
    beforeDestroy() {
      this.layoutHelpers.off("resize.dashboard-1");
    },
  };

</script>

<style lang="css">
  .country-flag {
    max-width: 20px;
    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
  }

  /*
 * Link
 */

  /* Links */

  .link {
    color: #484848;
  }

  /* unvisited link */
  .link:link {
    color: #484848 !important;
  }

  /* visited link */
  .link:visited {
    color: #484848 !important;
  }

  /* mouse over link */
  .link:hover {
    color: #6e6e6e !important;
  }

  /* selected link */
  .link:active {
    color: #484848 !important;
  }

  /* Timeline */

  ul.timeline {
    list-style-type: none;
    position: relative;
  }

  ul.timeline:before {
    content: " ";
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
  }

  ul.timeline>li {
    margin: 20px 0;
    padding-left: 20px;
  }

  ul.timeline>li:before {
    content: " ";
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #801529;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
  }

</style>
